// used for gci testing with migrated data
export default {
  apiGateway: {
      REGION: "us-west-2",
      URL: "https://hgylvxbvp6.execute-api.us-west-2.amazonaws.com/gcsop8"
  },
  cognito: {
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_2WkKRw5af",
      APP_CLIENT_ID: "6j20v157h77rtgt4e9lr9c6v36",
      IDENTITY_POOL_ID: "us-west-2:174191b7-869a-4fdd-b725-4495e4638e7e"
  }
}
